import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Icon, { Path } from './base/Icon';
import type { BaseIconProps } from './types';
type Props = BaseIconProps & {
  color?: string;
};
const F = t0 => {
  const $ = _c(6);
  const {
    size,
    height,
    width,
    color: t1
  } = t0;
  const color = t1 === undefined ? "rgb(var(--text-secondary-color))" : t1;
  const iconHeight = size || height || 63;
  const iconWidth = size || width || iconHeight * 47 / 63;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Path d="M29.22 12.73C24.46 12.73 20.8617 13.7783 18.425 15.875C15.9883 17.915 14.77 21.0033 14.77 25.14V28.795H39.25V39.845H14.77V61.52H1V25.225C1 17.575 3.38 11.625 8.14 7.375C12.9567 3.125 19.6717 1 28.285 1C31.685 1 34.8867 1.36833 37.89 2.105C40.8933 2.785 43.5 3.805 45.71 5.165L41.46 16.045C38.06 13.835 33.98 12.73 29.22 12.73Z" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== color || $[2] !== iconHeight || $[3] !== iconWidth || $[4] !== size) {
    t3 = <Icon viewBox="0 0 47 63" height={iconHeight} width={iconWidth} size={size} fill="none" stroke={color} strokeWidth="5">{t2}</Icon>;
    $[1] = color;
    $[2] = iconHeight;
    $[3] = iconWidth;
    $[4] = size;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default F;